module.exports = __webpack_public_path__ + "12b73ccf.png";